import { render, staticRenderFns } from "./potential.vue?vue&type=template&id=373f667c&scoped=true&"
import script from "./potential.vue?vue&type=script&lang=js&"
export * from "./potential.vue?vue&type=script&lang=js&"
import style0 from "./potential.vue?vue&type=style&index=0&id=373f667c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373f667c",
  null
  
)

export default component.exports